import { render, staticRenderFns } from "./sign-auth.vue?vue&type=template&id=0ebeea06&scoped=true&"
import script from "./sign-auth.vue?vue&type=script&lang=js&"
export * from "./sign-auth.vue?vue&type=script&lang=js&"
import style0 from "./sign-auth.vue?vue&type=style&index=0&id=0ebeea06&prod&lang=scss&"
import style1 from "./sign-auth.vue?vue&type=style&index=1&id=0ebeea06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebeea06",
  null
  
)

export default component.exports